export const GAME_PAGE_INTRO = 'GAME_PAGE_INTRO';
export const GAME_PAGE_INFO = 'GAME_PAGE_INFO';
export const GAME_PAGE_PROGRESS = 'GAME_PAGE_PROGRESS';

export const GAME_LOAD = 'GAME_LOAD';
export const GAME_SET_VIEW = 'GAME_SET_VIEW';
export const GAME_TOGGLE_MODAL = 'GAME_TOGGLE_MODAL';

export const GAME_LEVEL_UP_START = 'GAME_LEVEL_UP_START';
export const GAME_LEVEL_UP_SUCCESS = 'GAME_LEVEL_UP_SUCCESS';
export const GAME_LEVEL_UP_FAILURE = 'GAME_LEVEL_UP_FAILURE';

export const GAME_LOAD_HISTORY_START = 'GAME_LOAD_HISTORY_START';
export const GAME_LOAD_HISTORY_SUCCESS = 'GAME_LOAD_HISTORY_SUCCESS';
export const GAME_LOAD_HISTORY_FAILURE = 'GAME_LOAD_HISTORY_FAILURE';

export const GAME_LOAD_RANKING_START = 'GAME_LOAD_RANKING_START';
export const GAME_LOAD_RANKING_SUCCESS = 'GAME_LOAD_RANKING_SUCCESS';
export const GAME_LOAD_RANKING_FAILURE = 'GAME_LOAD_RANKING_FAILURE';

export const GAME_CHANGE_LEVEL_START = 'GAME_CHANGE_LEVEL_START';
export const GAME_CHANGE_LEVEL_SUCCESS = 'GAME_CHANGE_LEVEL_SUCCESS';
export const GAME_CHANGE_LEVEL_FAILURE = 'GAME_CHANGE_LEVEL_FAILURE';
